(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/banner_layouts/rectangular-image/assets/javascripts/render-component.js') >= 0) return;  svs.modules.push('/components/banner_layouts/rectangular-image/assets/javascripts/render-component.js');

'use strict';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const isServer = typeof exports === 'object';
const getImageData = (images, inputName, property, rootUrl) => {
  var _getSrc;
  const image = images === null || images === void 0 ? void 0 : images.find(_ref => {
    let {
      name,
      typeName
    } = _ref;
    return [name, typeName].includes(inputName);
  });
  const getSrc = () => image ? "".concat(rootUrl).concat(image[property]) : null;
  switch (property) {
    case 'url':
      return ((_getSrc = getSrc()) === null || _getSrc === void 0 ? void 0 : _getSrc.replace('{width}', '320')) || null;
    default:
      return image && property in image ? image[property] : null;
  }
};

async function renderComponent(model, widgetInfo, position, req) {
  var _model$contentType;
  let hbsCompiled;
  let format;
  let isAdmin;
  let rootUrl;
  if (isServer) {
    const trinidad = require('trinidad-core').core;
    const hbs = global.internalInstances.get('hbs');
    hbsCompiled = hbs.cache['components-banner_layouts-rectangular_image-rectangular_image'];
    format = trinidad.components.require('utils', 'format').api;
    isAdmin = req.userSession.hasRole(req.userSession.roles.INTERNAL);
    rootUrl = trinidad.config.options.cdn2;
  } else {
    hbsCompiled = svs.banner_layouts.rectangular_image.templates.rectangular_image;
    format = svs.utils.format;
    isAdmin = svs.core.userSession.hasRole(svs.core.userSession.roles.INTERNAL);
    const isPreview = svs.core.data.roles.includes(svs.core.userSession.roles.INTERNAL);
    rootUrl = isPreview ? '' : svs.core.config.data.svsconfig.cdn2;
  }
  const action = model.callToActions[0].actionConfig;
  const bannerHeight = 110;
  const bgImageSrc = getImageData(model.images, 'productImage', 'url', rootUrl);
  const hasBgImage = Boolean(bgImageSrc);
  const base64EmptyPixel = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
  const bgImageAltText = getImageData(model.images, 'productImage', 'altText');
  const contentType = (model === null || model === void 0 ? void 0 : (_model$contentType = model.contentType) === null || _model$contentType === void 0 ? void 0 : _model$contentType.split(':').pop()) || 'banner';
  const crm = model.targetOffer || '';
  const placeholderHeading = 'Exempelrubrik';
  const productOrLinkText = Boolean(model.layoutConfig.product) || Boolean(model.layoutConfig.linkText);
  const trackingStringTitle = format.safeString(model.title) || model.title;
  const trackingString = [widgetInfo.widgetType, widgetInfo.trackingId, position, model.layoutType, trackingStringTitle].join('/');
  return hbsCompiled(_objectSpread(_objectSpread({}, model.layoutConfig), {}, {
    action,
    bannerId: model.id,
    bannerHeight,
    bgImageAltText,
    bgImageSrc: bgImageSrc || base64EmptyPixel,
    contentType,
    crm,
    hasBgImage,
    isAdmin,
    placeholderHeading,
    productOrLinkText,
    trackingString
  })) || '';
}
if (isServer) {
  module.exports = {
    renderComponent
  };
} else {
  svs.banner_layouts.rectangular_image = {
    renderComponent
  };
}

 })(window);